
import React, { Fragment, useContext, useEffect } from 'react'

import { BusinessNavigation, DealerNavigation } from '../Menus/NavigationItems'
import { SessionContext } from '../../contexts/SessionProvider'
import SiteService from '../../services/SiteService'
import Enumeration from '../../enumeration'
import SideMenu from '../Menus/SideMenu'
import { useThemeContext, setEnableMobileMenu } from '../../contexts/ThemeProvider'

const VerticalNavWrapper = () =>
{
	const sessionContext = useContext(SessionContext)
	const [controller, dispatch] = useThemeContext()
	const { enableMobileMenu } = controller
	
	useEffect(() =>
	{

	}, [])
	
	const toggleSidebar = () =>
	{
		setEnableMobileMenu(dispatch, !enableMobileMenu)
	}
	
	return (
		<Fragment>
			<h5 className="app-sidebar__heading">Menu</h5>
			{
				// BUSINESS USERS
				(sessionContext.loginSession.isAuthenticated && SiteService.isInGroup(sessionContext.loginSession, Enumeration.UserGroups.Administrators)) &&
				<SideMenu content={ BusinessNavigation } onSelected={ toggleSidebar } className="vertical-nav-menu" />
			}
			{
				// DEALER USERS
				(sessionContext.loginSession.isAuthenticated && SiteService.isInGroup(sessionContext.loginSession, Enumeration.UserGroups.Dealers)) &&
				<SideMenu content={ DealerNavigation } onSelected={ toggleSidebar } className="vertical-nav-menu" />
			}
		</Fragment>
	)
}

export default VerticalNavWrapper
